<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <a href="/dashboard" class="header__link">
          <img src="../../assets/img/logotype.png" alt="Logotype" class="header__logotype"/>
        </a>
        <div class="header__singly cursor-pointer" @click="show_menu = !show_menu">
          <div class="utilizer">
            <div class="utilizer__name">{{ getAuthUser.name }}</div>
            <img :src="getAuthUser.avatar" :alt="getAuthUser.name" class="utilizer__photo"/>
          </div>
          <div class="header__drop">
            <div class="header__toggle"></div>
            <ul class="menu" :class="{open: show_menu}">
              <li class="menu__item">
                <a href="/" @click.prevent="onShowProfile" class="menu__link">Profile</a>
              </li>
              <li class="menu__item">
                <a href="/login" class="menu__link" @click.prevent="onLogout">Sign Out</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

  export default {
    name: "Header",
    data() {
      return {
        show_menu: false
      }
    },
    computed: {
      ...mapGetters([
        'getAuthUser',
      ])
    },
    methods: {
      ...mapActions([
        'logout',
        'showModal',
      ]),
      ...mapMutations([
        'setStatsFilters'
      ]),
      async onLogout() {
        await this.setStatsFilters({country: '0', partner: [0], period: 'All', year: 'All'})
        await this.logout()
      },
      onShowProfile() {
        setTimeout(function () {
          this.show_menu = false
        }, 100)
        this.showModal({modal: 'ModalUserCurrent'})
      }
    }
  }
</script>

<style>

</style>